import { useEffect } from "react";

function CloseModalButton() {
  const closeModal = () => {
    localStorage.setItem("politicaPrivacidade", "true");
    const cookieModal = document.querySelector("#cookie-modal") as HTMLElement;
    cookieModal?.classList.add("hidden");
  };

  useEffect(() => {
    if (typeof document === "undefined") return;

    const cookieModal = document.querySelector("#cookie-modal") as HTMLElement;
    if (!cookieModal) return;

    const isUserAgreed = localStorage.getItem("politicaPrivacidade") === "true";

    if (isUserAgreed) {
      cookieModal.classList.add("hidden");
    } else {
      cookieModal.classList.remove("hidden");
    }

    // Event delegation como fallback caso onClick não funcione
    const handleClick = (e: MouseEvent) => {
      const button = (e.target as HTMLElement).closest("button");
      if (button?.textContent?.trim() === "Concordar e fechar") {
        closeModal();
      }
    };

    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, []);

  return (
    <button
      className="max-w-full w-[249px] h-12 bg-[#1A1A1A] rounded-full border-0 text-sm text-[#fff]"
      type="button"
      onClick={closeModal}
    >
      Concordar e fechar
    </button>
  );
}

export default CloseModalButton;
